import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Globals } from '../../ressources/variables/globals';
import { Musiques } from '../../ressources/types/musiques';
import { MusiquesMix } from '../../ressources/types/musiquesMix';

/**
 * Service pour la synchronisation avec la base MySQL
 * Note: L'authentification est gérée automatiquement via les cookies de session Laravel
 * grâce à l'intercepteur CredentialsInterceptor
 */
@Injectable({
  providedIn: 'root'
})
export class MysqlSyncService {

  serverEndpoint = Globals.serverEndpoint;

  sessionID = 0;

  dataID = [];

  constructor(private http: HttpClient) { }

  initSession(folder: string) {
    this.sessionID = 0;
    this.dataID = [];
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('folder', folder);

    this.http.post<any>(this.serverEndpoint + '/api/initSessionSql', body.toString(), { headers }).toPromise()
      .then(connection => {
        console.log(connection);
        this.sessionID = connection.insertId;
      }).catch(err => {
        console.log(err);
        this.sessionID = 0;
      });
  }

  newImport(filename: string, folder: string, metadata: any, pos: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const sqlData = [{
      file: filename,
      folder: folder,
      metadata: metadata,
      id_session: this.sessionID,
      position: pos
    }];
    const body = new HttpParams()
      .set('sqlData', JSON.stringify(sqlData));

    return new Promise((resolve, reject) => {
      this.http.post<any>(this.serverEndpoint + '/api/syncImportSql', body.toString().replace(/\+/gi, '%2B'), { headers }).toPromise()
        .then(connection => {
          resolve(connection);
        }).catch(err => {
          reject(err);
        });
    });
  }

  syncImport(dataFiles: Musiques[], dataMix: MusiquesMix[]) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const sqlData = [];
    let index = 0;
    for (const e of dataFiles) {
      sqlData.push(e);
      sqlData[index].id = this.dataID[index].id;
      sqlData[index].mix = dataMix[index].mix;
      sqlData[index].id_session = this.sessionID;
      index++;
    }
    console.log(sqlData);
    const body = new HttpParams()
      .set('sqlData', JSON.stringify(sqlData));

    return new Promise((resolve, reject) => {
      this.http.post<any>(this.serverEndpoint + '/api/syncImportSql', body.toString().replace(/\+/gi, '%2B'), { headers }).toPromise()
        .then(connection => {
          resolve(connection);
        }).catch(err => {
          reject(err);
        });
    });
  }

  masquerSession(folderSession: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('folderSession', folderSession);

    return new Promise((resolve, reject) => {
      this.http.post<any>(this.serverEndpoint + '/api/masquerSessionSql', body.toString(), { headers }).toPromise()
        .then(connection => {
          resolve(connection);
        }).catch(err => {
          reject(err);
        });
    });
  }
}
